import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuthContext } from "@/contexts/AuthContext";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuthContext();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Lütfen e-posta adresinizi girin.");
      return;
    }
    setLoading(true);
    try {
      await resetPassword(email.trim());
      setSent(true);
      toast.success("Şifre sıfırlama bağlantısı gönderildi!");
    } catch (err) {
      toast.error("Bir hata oluştu. " + (err instanceof Error ? err.message : "Lütfen tekrar deneyin."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Şifremi Unuttum</h1>
              <p className="text-sm text-gray-500">
                E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.
              </p>
            </div>

            {sent ? (
              <div className="text-center space-y-4">
                <div className="w-14 h-14 flex items-center justify-center bg-blue-50 rounded-full mx-auto">
                  <i className="ri-mail-send-line text-2xl text-blue-600"></i>
                </div>
                <p className="text-sm text-gray-600">
                  <span className="font-semibold">{email}</span> adresine bir sıfırlama bağlantısı gönderdik.
                </p>
                <p className="text-xs text-gray-400">
                  E-postayı göremiyorsanız spam klasörünü kontrol edin.
                </p>
                <Link
                  to="/login"
                  className="inline-block px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-xl transition-all cursor-pointer"
                >
                  Giriş Sayfasına Dön
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    E-posta Adresi
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ornek@mail.com"
                    className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors"
                    required
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-semibold rounded-xl transition-all cursor-pointer"
                >
                  {loading ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-loader-4-line animate-spin"></i>
                      Gönderiliyor...
                    </span>
                  ) : (
                    "Sıfırlama Bağlantısı Gönder"
                  )}
                </button>

                <div className="text-center text-sm text-gray-500">
                  <Link to="/login" className="text-blue-600 hover:text-blue-700 font-semibold">
                    Giriş sayfasına dön
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}